<template>
    <div>
        <div v-if="this.buscando">
            <v-container fluid>
                <v-row>
                    <v-col>
                        <h2 v-text="'Se ha lanzado la búsqueda. Consulte en el listado para revisar los resultados.'">
                        </h2>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div v-else>
            <v-form ref="formulario">
                <v-container fluid>
                    <v-row>
                        <v-col>
                            <h2 v-text="this.editing ? this.titulo : 'Nueva'"></h2>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col>
                            <v-radio-group v-model="currentBusqueda.tipobase" row mandatory :disabled="this.editing">
                                <v-radio indeterminate value="pt" label="Platino"></v-radio>
                                <v-radio indeterminate value="px" label="Peroxido"></v-radio>
                                <v-radio indeterminate value="all" label="Ambas"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col>
                            <v-radio-group v-model="currentBusqueda.postcurado" row mandatory :disabled="this.editing">
                                <v-radio indeterminate value="sin" label="Sin Postcurado"></v-radio>
                                <v-radio indeterminate value="con" label="Con Postcurado"></v-radio>
                                <v-radio indeterminate value="all" label="Ambas"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <v-row align="center">
                        <v-col>
                            <v-text-field v-model="currentBusqueda.temp_servicio"
                                :rules="[(v) => !!v || 'Temperatura es necesario']" label="Temperatura Servicio"
                                prepend-icon="mdi-thermometer" type="number" suffix="ºC" required :disabled="this.editing">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="currentBusqueda.densidad" label="Densidad"
                                prepend-icon="mdi-dots-hexagon" type="number" :disabled="this.editing">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-text-field v-model="currentBusqueda.dureza" :rules="[(v) => !!v || 'Dureza es necesario']"
                                label="Dureza" prepend-icon="mdi-alpha-d-circle" type="number" required
                                :disabled="this.editing">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-autocomplete v-model="currentBusqueda.proceso"
                                :rules="[(v) => !!v || 'Proceso es necesario']" :items="proceso" :filter="customFilter"
                                item-text="name" item-value="value" label="Proceso" clearable :disabled="this.editing">
                            </v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row align="center">
                        <v-col>
                            <v-autocomplete v-model="currentBusqueda.id_color" :items="colores" :loading="isLoading"
                                :item-text=getColorName item-value="id_color" label="Color" prepend-icon="mdi-palette"
                                return-object clearable :disabled="this.editing">
                            </v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row align="center">
                        <v-col>
                            <v-checkbox :indeterminate="currentBusqueda.aceite == null" v-model="currentBusqueda.aceite"
                                label="Aceite" :disabled="this.editing"></v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox :indeterminate="currentBusqueda.cables == null" v-model="currentBusqueda.cables"
                                label="Cables" :disabled="this.editing"></v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox v-model="currentBusqueda.esponja" label="Esponja" :disabled="this.editing">
                            </v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox :indeterminate="currentBusqueda.desmoldeo == null"
                                v-model="currentBusqueda.desmoldeo" label="Desmoldeo" :disabled="this.editing"></v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox :indeterminate="currentBusqueda.fda == null" v-model="currentBusqueda.fda"
                                label="FDA" :disabled="this.editing">
                            </v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox :indeterminate="currentBusqueda.fuego == null" v-model="currentBusqueda.fuego"
                                label="Fuego" :disabled="this.editing"></v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox :indeterminate="currentBusqueda.grasa == null" v-model="currentBusqueda.grasa"
                                label="Grasa" :disabled="this.editing"></v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox :indeterminate="currentBusqueda.green_strength == null"
                                v-model="currentBusqueda.green_strength" label="Green Strength" :disabled="this.editing">
                            </v-checkbox>
                        </v-col>
                    </v-row>

                    <v-row>Criterio de Ordenación:</v-row>
                    <v-row align="center">
                        <v-col>
                            <v-radio-group v-model="ordenacion" row :disabled="this.editing">
                                    <v-radio indeterminate value="alargamiento" label="Alargamiento"></v-radio>
                                    <v-radio indeterminate value="carga_rot_mpa" label="Carga Rot. MPA"></v-radio>
                                    <v-radio indeterminate value="desgarro" label="Desgarro"></v-radio>
                                    <v-radio indeterminate value="c_set" label="Compression Set"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    
                    <v-row align="center">
                        <v-col align="center">

                            <div v-if="this.loadingFormulas">
                                <v-progress-linear indeterminate rounded height="6"></v-progress-linear>
                            </div>
                            <div v-else>
                                <v-btn v-if="this.editing" color="error" class="mr-2" @click="deleteBusqueda">
                                    Borrar
                                </v-btn>
                            </div>

                            <v-btn v-if="!this.editing" color="primary" x-large @click="iaSearch" :loading="searching"
                                :disabled="searching" class="ma-2">
                                <v-icon left>mdi-brain</v-icon>
                                Buscar
                                <template v-slot:loader>
                                    <span>Procesando</span>
                                </template>
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row v-if="this.editing">
                        <v-col v-if="res_formulas">
                            <ListaSugerencias :key="listaKey" :busqueda="res_formulas" title="Fórmulas Sugeridas" />
                        </v-col>
                    </v-row>

                </v-container>
            </v-form>
        </div>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
import SugerenciasDataService from "@/services/SugerenciasDataService";
import AplicacionesDataService from "@/services/AplicacionesDataService";
import ColoresDataService from "@/services/ColoresDataService";
import ListaSugerencias from "@/components/ListadoFormulas.vue";
import FormulasDataService from "@/services/FormulasDataService";


export default {
    name: "SugerenciaId",
    props: ['id'],
    data() {
        return {
            aplicaciones: [],
            colores: [],
            editing: false,
            titulo: "",
            isLoading: false,
            formulas: null,
            res_formulas: null,
            loadingFormulas: false,
            ordenacion: 'default',
            currentBusqueda: {
                id_busqueda: 0,
                tipobase: null,
                platino: null,
                peroxido: null,
                dureza: null,
                temp_servicio: null,
                densidad: null,
                proceso: null,
                id_color: null,
                aceite: null,
                cables: null,
                desmoldeo: null,
                esponja: false,
                fda: null,
                fuego: null,
                grasa: null,
                green_strength: null,
                postcurado: false,
                sin_postcurado: false,
                alargamiento: null,
                carga_rot_mpa: null,
                c_set: null,
                desgarro: null,
            },
            proceso: [
                { name: 'Autoclave', abbr: 'AC', value: 'autoclave' },
                { name: 'Calandra', abbr: 'C', value: 'calandra' },
                { name: 'Extrusion', abbr: 'E', value: 'extrusion' },
                { name: 'Moldeo', abbr: 'M', value: 'moldeo' },
            ],
            sortBy: 'fecha',
            sortDesc: true,
            listaKey: 0,
            searching: false,
            buscando: false,
        };
    },
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        getBusqueda(id) {
            this.loadingFormulas = true;
            SugerenciasDataService.get(id)
                .then((response) => {
                    this.currentBusqueda = response.data;
                    // console.log("SUGERENCIA"); console.log(response.data);

                    if(this.currentBusqueda.alargamiento) this.ordenacion = "alargamiento";
                    else if(this.currentBusqueda.carga_rot_mpa) this.ordenacion = "carga_rot_mpa";
                    else if(this.currentBusqueda.c_set) this.ordenacion = "c_set";
                    else if(this.currentBusqueda.desgarro) this.ordenacion = "desgarro";

                    function pad2(n) {
                        return (n < 10 ? '0' : '') + n;
                    }
                    let date = new Date(this.currentBusqueda.created_at);
                    let month = pad2(date.getMonth() + 1);//months (0-11)
                    let day = pad2(date.getDate());//day (1-31)
                    let year = date.getFullYear();
                    let hh = pad2(date.getHours());
                    let mn = pad2(date.getMinutes());
                    let formattedDate = year + "/" + month + "/" + day + " " + hh + ":" + mn;
                    this.titulo = "Busqueda " + formattedDate;

                    if (this.currentBusqueda.platino && this.currentBusqueda.peroxido) {
                        this.currentBusqueda.tipobase = "all"
                    } else if (this.currentBusqueda.platino) {
                        this.currentBusqueda.tipobase = "pt"
                    } else {
                        this.currentBusqueda.tipobase = "px"
                    }
                    if (this.currentBusqueda.con_postcurado && this.currentBusqueda.sin_postcurado) {
                        this.currentBusqueda.postcurado = "all"
                    } else if (this.currentBusqueda.con_postcurado) {
                        this.currentBusqueda.postcurado = "con"
                    } else {
                        this.currentBusqueda.postcurado = "sin"
                    }
                    this.listaKey += 1;
                })
                .catch((e) => {
                    console.log(e);
                });

            FormulasDataService.sugeridas(id)
                .then((response) => {
                    this.res_formulas = response.data.map(this.getPrecio);
                    this.loadingFormulas = false;
                });
        },
        deleteBusqueda() {
            SugerenciasDataService.delete(this.currentBusqueda.id_busqueda)
                .then((response) => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.$router.push({ name: "SugerenciasList" });
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        iaSearch() {
            this.searching = true;
            if (this.$refs.formulario.validate()) {
                if(this.ordenacion == "alargamiento") this.currentBusqueda.alargamiento = true;
                else if(this.ordenacion == "carga_rot_mpa") this.currentBusqueda.carga_rot_mpa = true;
                else if(this.ordenacion == "c_set") this.currentBusqueda.c_set = true;
                else if(this.ordenacion == "desgarro") this.currentBusqueda.desgarro = true;
                
                if(this.currentBusqueda.esponja == null) this.currentBusqueda.esponja = false;              
                let data = {
                    platino: this.currentBusqueda.tipobase === "all" ? true : this.currentBusqueda.tipobase === "pt",
                    peroxido: this.currentBusqueda.tipobase === "all" ? true : this.currentBusqueda.tipobase === "px",
                    dureza: this.currentBusqueda.dureza,
                    temp_servicio: this.currentBusqueda.temp_servicio,
                    densidad: this.currentBusqueda.densidad,
                    proceso: this.currentBusqueda.proceso,
                    id_color_id: this.currentBusqueda.id_color ? this.currentBusqueda.id_color.id_color : null,
                    aceite: this.currentBusqueda.aceite,
                    cables: this.currentBusqueda.cables,
                    desmoldeo: this.currentBusqueda.desmoldeo,
                    esponja: this.currentBusqueda.esponja,
                    fda: this.currentBusqueda.fda,
                    fuego: this.currentBusqueda.fuego,
                    grasa: this.currentBusqueda.grasa,
                    green_strength: this.currentBusqueda.green_strength,
                    con_postcurado: this.currentBusqueda.postcurado == "all" ? true : this.currentBusqueda.postcurado === "con",
                    sin_postcurado: this.currentBusqueda.postcurado == "all" ? true : this.currentBusqueda.postcurado === "sin",

                    alargamiento: this.currentBusqueda.alargamiento,
                    carga_rot_mpa: this.currentBusqueda.carga_rot_mpa,
                    c_set: this.currentBusqueda.c_set,
                    desgarro: this.currentBusqueda.desgarro,

                };

                SugerenciasDataService.create(data)
                    .then((response) => {
                        this.searching = false;
                        this.setSnack({ message: response.data.message, color: "success" });
                        this.buscando = true;
                    })
                    .catch((e) => {
                        this.searching = false;
                        if (e.response.data.detail) {
                            this.setSnack({ message: e.response.data.detail, color: "error" });
                        } else {
                            this.setSnack({ message: e.message, color: "error" });
                        }
                        console.log(e);
                    });
            } else {
                this.searching = false;
                this.setSnack({ message: "Complete los campos necesarios.", color: "error" });
            }
        },
        customFilter(item, queryText, itemText) {
            const textOne = item.name.toLowerCase()
            const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1 ||
                textTwo.indexOf(searchText) > -1
        },
        getColorName(item) {
            let str_color = item.nombre;
            if (item.ral != "") {
                str_color += " (" + item.ral + ")";
            }
            if (item.referencia != "") {
                str_color += " [" + item.referencia + "]";
            }
            return str_color
        },
        getPrecio(item) {
            let ppc_total = 0.0
            var dict = new Object();

            for (const base of item.formula_base) {
                for (const proveedor of base.cod_base.proveedor_base) {
                    ppc_total += base.ppc;
                    dict[base.cod_base.cod_base] = {};
                    dict[base.cod_base.cod_base].ppc = base.ppc;
                    dict[base.cod_base.cod_base].precio = proveedor.precio;
                }
            }

            for (const aditivo of item.formula_aditivo) {
                for (const proveedor of aditivo.cod_aditivo.proveedor_aditivo) {
                    ppc_total += aditivo.ppc;
                    dict[aditivo.cod_aditivo.cod_aditivo] = {};
                    dict[aditivo.cod_aditivo.cod_aditivo].ppc = aditivo.ppc;
                    dict[aditivo.cod_aditivo.cod_aditivo].precio = proveedor.precio;
                }
            }

            let total = 0.0;
            for (var key in dict) {
                var value = dict[key];
                total += (value.ppc / ppc_total) * value.precio
            }
            item.precio = total.toFixed(2);
            return item;
        },
    },
    mounted() {
        this.editing = false;
        if (this.$route.params.id) {
            this.getBusqueda(this.$route.params.id);
            this.editing = true;
        }
        AplicacionesDataService.getSimple()
            .then((response) => {
                this.aplicaciones = response.data;
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));

        ColoresDataService.getAll()
            .then((response) => {
                this.colores = response.data
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));
    },
    watch: {
        '$route.params.id'(newId, oldId) {
            this.$refs.formulario.reset();

            if (newId != null) {
                this.getBusqueda(newId);
                this.editing = true;
            } else {
                this.editing = false;
            }
            this.$refs.formulario.resetValidation();
        },
    },
    components: { ListaSugerencias }
};
</script>